/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		5: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-game","1":"route-win","2":"route-select","3":"route-loss","4":"route-home"}[chunkId]||chunkId) + ".chunk." + {"0":"5e77f","1":"75dac","2":"c4dda","3":"c782b","4":"2963c"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/stress-game/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.exec = exports.Link = exports.Route = exports.Router = exports.route = exports.getCurrentUrl = exports.subscribers = undefined;

var _preact = __webpack_require__("KM04");

var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.props;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.props.default ? 0 : rank(vnode.props.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}
	routeFromLink(e.currentTarget || e.target || this);
	return prevent(e);
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href')) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		var children = (0, _preact.toChildArray)(this.props.children);
		return this.getMatchingChildren(children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this.setState({ url: url });

		var didRoute = this.canRoute(url);

		// trigger a manual re-route if we're not in the middle of an update:
		if (!this.updating) {
			this.forceUpdate();
		}

		return didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.props.path, vnode.props);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return (0, _preact.cloneElement)(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren((0, _preact.toChildArray)(children), url, true);

		var current = active[0] || null;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(_preact.Component);

var Link = function Link(props) {
	return (0, _preact.createElement)('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return (0, _preact.createElement)(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;
Router.exec = exec;

exports.subscribers = subscribers;
exports.getCurrentUrl = getCurrentUrl;
exports.route = route;
exports.Router = Router;
exports.Route = Route;
exports.Link = Link;
exports.exec = exec;
exports.default = Router;
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "DHvs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.stressDotMap = exports.setupPath = exports.generateGridCards = exports.collectData = undefined;

var _collectData = __webpack_require__("LIV4");

var _collectData2 = _interopRequireDefault(_collectData);

var _generateGridCards = __webpack_require__("QXgo");

var _generateGridCards2 = _interopRequireDefault(_generateGridCards);

var _setupPath = __webpack_require__("yQgl");

var _setupPath2 = _interopRequireDefault(_setupPath);

var _stressMap = __webpack_require__("klTG");

var _stressMap2 = _interopRequireDefault(_stressMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.collectData = _collectData2.default;
exports.generateGridCards = _generateGridCards2.default;
exports.setupPath = _setupPath2.default;
exports.stressDotMap = _stressMap2.default;

/***/ }),

/***/ "E1C8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("iOg+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "GoAI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("K7g0") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "JdXh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var wordList = {
  '010': ['adjacent', 'albeit', 'assemble', 'assembled', 'assembles', 'assemblies', 'assembly', 'collapses', 'collapsing', 'compiling', 'conceiving', 'convinces', 'convincing', 'depresses', 'depressing', 'depression', 'encounter', 'encountered', 'encounters', 'enormous', 'persisted', 'persistence', 'persistent', 'persisting', 'reluctance', 'reluctant', 'adjusted', 'adjusting', 'adjustment', 'adjustments', 'unaltered', 'amended', 'amending', 'amendment', 'amendments', 'awareness', 'compounded', 'compounding', 'conflicted', 'conflicting', 'consultant', 'consultants', 'consulted', 'consulting', 'declining', 'discretion', 'redrafted', 'redrafting', 'enable', 'enabled', 'enables', 'enforcement', 'enforces', 'enforcing', 'evolving', 'expanded', 'expanding', 'expansion', 'expansive', 'exposes', 'exposing', 'exposure', 'exposures', 'external', 'unlicensed', 'logician', 'logicians', 'objective', 'perspective', 'perspectives', 'precisely', 'precision', 'pursuing', 'rejected', 'rejecting', 'rejection', 'rejections', 'unstable', 'sustaining', 'symbolic', 'transition', 'transitions', 'adapted', 'adapting', 'adaptive', 'unaided', 'comprises', 'comprising', 'confirming', 'conversion', 'conversions', 'converted', 'converting', 'denial', 'denials', 'denying', 'disposal', 'disposes', 'disposing', 'dynamic', 'dynamics', 'equipment', 'equipping', 'extracted', 'extracting', 'extraction', 'foundation', 'foundations', 'prohibit', 'prohibits', 'quotation', 'quotations', 'releases', 'releasing', 'reversal', 'reverses', 'reversing', 'reversals', 'submission', 'submissions', 'submitted', 'submitting', 'successor', 'succession', 'successions', 'successive', 'successors', 'survival', 'surviving', 'survivor', 'survivors', 'transmission', 'transmissions', 'transmitted', 'transmitting', 'uniquely', 'uniqueness', 'apparent', 'commitment', 'commitments', 'committed', 'committing', 'conferring', 'contrasted', 'contrasting', 'contrastive', 'debated', 'debating', 'dimension', 'dimensions', 'domestic', 'domestics', 'imposes', 'predicted', 'predicting', 'prediction', 'predictions', 'projected', 'projecting', 'projection', 'projections', 'promoted', 'promoter', 'promoters', 'promoting', 'promotion', 'promotions', 'resolving', 'retaining', 'retainer', 'retainers', 'retention', 'retentive', 'statistic', 'statistics', 'summation', 'approaches', 'approaching', 'assesses', 'assessing', 'assessment', 'assessments', 'assuming', 'assumption', 'assumptions', 'conception', 'consisted', 'consistent', 'consisting', 'created', 'creating', 'creation', 'creations', 'creative', 'creator', 'creators', 'defining', 'deriving', 'distribute', 'establish', 'established', 'exported', 'exporter', 'exporters', 'exporting', 'financing', 'occurrence', 'occurring', 'percentage', 'procedure', 'procedures', 'proceeded', 'proceeding', 'proceedings', 'requirement', 'requirements', 'researches', 'researching', 'responded', 'respondent', 'respondents', 'responding', 'responses', 'responsive', 'specific', 'specifics', 'restructure', 'restructured', 'restructures', 'unstructured', 'component', 'components', 'consensus', 'consented', 'consenting', 'constraining', 'contribute', 'contributes', 'convention', 'convening', 'conventions', 'deduces', 'deducing', 'deduction', 'deductions', 'emphatic', 'ensuring', 'excluded', 'excluding', 'exclusion', 'exclusions', 'exclusive', 'location', 'locations', 'negating', 'proportion', 'proportions', 'unpublished', 'reacted', 'reacting', 'reaction', 'reactions', 'reactive', 'reactor', 'reactors', 'reliance', 'reliant', 'relying', 'removal', 'removals', 'removing', 'schematic', 'sequential', 'sufficient', 'abandon', 'abandoned', 'abandons', 'appendix', 'appended', 'appending', 'uncharted', 'conformance', 'conforming', 'conformist', 'conformists', 'denoted', 'denoting', 'detected', 'detecting', 'detection', 'detective', 'detectives', 'detector', 'detectors', 'displacement', 'displaces', 'displacing', 'dramatic', 'exhibit', 'exhibits', 'intenseness', 'intension', 'prospective', 'restoring', 'revises', 'revising', 'revision', 'revisions', 'reschedule', 'rescheduled', 'reschedules', 'unscheduled', 'thematic', 'assurance', 'assuring', 'attaining', 'attainment', 'attainments', 'coherent', 'coherence', 'commences', 'commencement', 'commencing', 'concurrent', 'confining', 'devices', 'devoted', 'devoting', 'devotion', 'devotions', 'diminish', 'diminished', 'distorted', 'distorting', 'distortion', 'distortions', 'eroded', 'eroding', 'erosion', 'unfounded', 'inherent', 'maturing', 'refinement', 'refinements', 'refining', 'relaxes', 'relaxing', 'restraining', 'suspended', 'suspending', 'suspension', 'achievement', 'achievements', 'achieving', 'acquire', 'acquired', 'acquires', 'affected', 'affecting', 'affective', 'assistance', 'assistant', 'assistants', 'assisted', 'assisting', 'commission', 'commissioned', 'commissions', 'computer', 'computed', 'computers', 'computing', 'concluded', 'concluding', 'conclusion', 'conclusions', 'conclusive', 'conducted', 'conducting', 'constructed', 'constructing', 'construction', 'constructions', 'constructive', 'consumer', 'consumers', 'consuming', 'consumption', 'uncultured', 'designer', 'designers', 'designing', 'distinction', 'distinctions', 'distinctive', 'distinctly', 'equated', 'equating', 'equation', 'equations', 'refocus', 'refocused', 'refocussed', 'uninjured', 'maintaining', 'abnormal', 'obtaining', 'perceiving', 'perception', 'perceptions', 'potential', 'resided', 'residing', 'resourceful', 'restricted', 'restricting', 'restriction', 'restrictions', 'restrictive', 'securely', 'securing', 'selected', 'selecting', 'selection', 'selections', 'selective', 'selector', 'selectors', 'strategic', 'tradition', 'traditions', 'transference', 'transferring', 'abstraction', 'abstractions', 'acknowledge', 'acknowledged', 'assigning', 'assignment', 'assignments', 'attaches', 'attaching', 'attachment', 'attachments', 'citation', 'citations', 'displaying', 'edition', 'editions', 'enhancement', 'enhances', 'enhancing', 'exceeded', 'exceeding', 'explicit', 'migration', 'migrations', 'preceded', 'preceding', 'presuming', 'presumption', 'presumptions', 'recover', 'recovered', 'recovers', 'revealing', 'transforming', 'transported', 'transporter', 'transporters', 'transporting'],
  '01': ['collapse', 'collapsed', 'compile', 'compiled', 'compiles', 'conceive', 'conceived', 'conceives', 'convince', 'convinced', 'depress', 'depressed', 'persist', 'persists', 'whereby', 'adjust', 'adjusts', 'amend', 'amends', 'aware', 'consult', 'consults', 'decline', 'declined', 'declines', 'discrete', 'redraft', 'enforce', 'enforced', 'evolve', 'evolved', 'evolves', 'expand', 'expands', 'expose', 'exposed', 'precise', 'pursue', 'pursued', 'pursues', 'pursuit', 'pursuits', 'sustain', 'sustained', 'sustains', 'whereas', 'adapt', 'adapts', 'comprise', 'comprised', 'confirm', 'confirmed', 'confirms', 'deny', 'denied', 'denies', 'dispose', 'disposed', 'equip', 'equipped', 'equips', 'release', 'released', 'reverse', 'reversed', 'submit', 'survive', 'survived', 'survives', 'transmit', 'transmits', 'unique', 'commit', 'commits', 'confer', 'conferred', 'confers', 'debate', 'debates', 'despite', 'predict', 'predicts', 'promote', 'promotes', 'regime', 'regimes', 'resolve', 'resolved', 'resolves', 'retain', 'retained', 'retains', 'unstressed', 'approach', 'approached', 'assess', 'assessed', 'assume', 'assumed', 'assumes', 'consist', 'consists', 'create', 'creates', 'define', 'defined', 'defines', 'derive', 'derived', 'derives', 'occur', 'occurred', 'occurs', 'percent', 'proceed', 'proceeds', 'researched', 'respond', 'responds', 'response', 'consent', 'consents', 'constrain', 'constrained', 'constrains', 'constraint', 'constraints', 'convene', 'convenes', 'convened', 'deduce', 'deduced', 'ensure', 'ensured', 'ensures', 'exclude', 'excludes', 'negate', 'negates', 'react', 'reacts', 'rely', 'relied', 'relies', 'remove', 'removed', 'removes', 'technique', 'techniques', 'append', 'appends', 'conform', 'conformed', 'conforms', 'denote', 'denotes', 'detect', 'detects', 'displace', 'displaced', 'restore', 'restored', 'restores', 'revise', 'revised', 'assure', 'assured', 'assures', 'attain', 'attained', 'attains', 'behalf', 'commence', 'commenced', 'confine', 'confined', 'device', 'devote', 'devotes', 'distort', 'distorts', 'erodes', 'mature', 'matured', 'matures', 'refine', 'refined', 'refines', 'relax', 'relaxed', 'restrain', 'restrained', 'restrains', 'restraint', 'restraints', 'suspend', 'suspends', 'achieve', 'achieved', 'achieves', 'affect', 'affects', 'assist', 'assists', 'compute', 'conclude', 'concludes', 'conducts', 'consume', 'consumed', 'consumes', 'design', 'designed', 'designs', 'distinct', 'equate', 'equates', 'maintain', 'maintained', 'maintains', 'obtain', 'obtained', 'obtains', 'perceive', 'perceived', 'perceives', 'reside', 'resides', 'restrict', 'restricts', 'secure', 'secured', 'secures', 'select', 'selects', 'assign', 'assigned', 'assigns', 'attach', 'attached', 'display', 'displayed', 'displays', 'diverse', 'domain', 'domains', 'enhance', 'enhanced', 'estate', 'estates', 'exceed', 'exceeds', 'precede', 'precedes', 'presume', 'presumed', 'presumes', 'reveal', 'revealed', 'reveals', 'transformed', 'transforms'],
  '10': ['colleague', 'colleagues', 'levy', 'levies', 'panel', 'panelled', 'panels', 'poses', 'posing', 'alter', 'altered', 'alters', 'challenge', 'challenged', 'clauses', 'drafted', 'drafting', 'image', 'licence', 'license', 'licensed', 'logic', 'margin', 'margins', 'mental', 'notion', 'notions', 'stable', 'styling', 'stylish', 'symbol', 'symbols', 'target', 'targets', 'transit', 'transits', 'version', 'versions', 'aided', 'aiding', 'channel', 'channelled', 'channels', 'classic', 'classics', 'couple', 'coupled', 'coupling', 'couples', 'filing', 'global', 'graded', 'grading', 'quoted', 'quoting', 'thesis', 'theses', 'topic', 'topics', 'civil', 'coded', 'coding', 'cycle', 'cycled', 'cycles', 'cyclic', 'error', 'errors', 'ethnic', 'granted', 'granting', 'label', 'labeled', 'labelled', 'labels', 'option', 'options', 'phases', 'phasing', 'prior', 'series', 'status', 'stresses', 'stressful', 'stressing', 'summing', 'concept', 'concepts', 'context', 'data', 'export', 'exports', 'factor', 'factored', 'factors', 'function', 'functioned', 'functions', 'issue', 'issued', 'issues', 'labour', 'labor', 'labored', 'labors', 'laboured', 'labours', 'legal', 'major', 'method', 'methods', 'processed', 'section', 'sectioned', 'sections', 'sector', 'sectors', 'sources', 'sourcing', 'structure', 'structured', 'structures', 'vary', 'varied', 'varies', 'comment', 'comments', 'constant', 'constants', 'coring', 'funded', 'funder', 'funders', 'funding', 'instance', 'layer', 'layered', 'layers', 'linkage', 'linking', 'minor', 'minors', 'partner', 'partners', 'publish', 'published', 'scheming', 'sequence', 'sequenced', 'sexes', 'shifted', 'shifting', 'valid', 'volume', 'volumes', 'bias', 'biased', 'charted', 'charting', 'crucial', 'drama', 'dramas', 'pluses', 'prospect', 'prospects', 'random', 'schedule', 'scheduled', 'schedules', 'tension', 'tensely', 'tenser', 'tensest', 'tensions', 'via', 'bulky', 'ceaseless', 'ceases', 'ceasing', 'ethic', 'ethics', 'founded', 'founder', 'founders', 'founding', 'passive', 'portion', 'portions', 'rigid', 'routed', 'routing', 'teaming', 'trigger', 'triggered', 'triggers', 'vision', 'visions', 'chapter', 'chapters', 'credit', 'credits', 'culture', 'cultured', 'cultures', 'feature', 'featured', 'features', 'final', 'finals', 'focus', 'focused', 'focussed', 'injure', 'injured', 'injures', 'item', 'items', 'journal', 'journals', 'normal', 'purchase', 'purchased', 'ranges', 'ranging', 'region', 'regions', 'resource', 'resourced', 'seeking', 'abstracts', 'author', 'authored', 'authors', 'bonded', 'bonding', 'briefing', 'briefly', 'cited', 'citing', 'edit', 'edits', 'expert', 'experts', 'gender', 'genders', 'index', 'indexed', 'lecture', 'lectured', 'lectures', 'migrant', 'migrants', 'motive', 'motives', 'neutral', 'taping', 'traces', 'tracing'],
  '100': ['panelling', 'altering', 'challenger', 'challengers', 'challenges', 'challenging', 'energy', 'energies', 'entity', 'entities', 'imagery', 'images', 'licences', 'licensing', 'licenses', 'logical', 'logically', 'marginal', 'medical', 'mentally', 'monitor', 'monitored', 'monitors', 'primacy', 'sustenance', 'targeted', 'targeting', 'transited', 'transiting', 'channelling', 'chemical', 'chemically', 'chemicals', 'classical', 'definite', 'infinite', 'globally', 'inference', 'media', 'solely', 'topical', 'ultimate', 'visible', 'visibly', 'annual', 'cyclical', 'implement', 'implements', 'labelling', 'obvious', 'occupant', 'occupants', 'optional', 'principal', 'principally', 'subsequent', 'summary', 'summaries', 'summarise', 'summarised', 'analyst', 'area', 'areas', 'benefit', 'benefits', 'contracted', 'contracting', 'evident', 'evidenced', 'evidence', 'factoring', 'formula', 'formulas', 'functional', 'functioning', 'issuing', 'labouring', 'legally', 'period', 'periods', 'policy', 'policies', 'principle', 'principled', 'principles', 'processes', 'processing', 'researcher', 'researchers', 'sectioning', 'similar', 'structural', 'structuring', 'theorist', 'theorists', 'variance', 'variant', 'variants', 'varying', 'commented', 'commenting', 'constancy', 'constantly', 'corporates', 'document', 'documents', 'dominance', 'dominant', 'emphasis', 'emphasise', 'emphasised', 'immigrant', 'immigrants', 'instances', 'layering', 'linkages', 'maximum', 'negative', 'negatives', 'physical', 'publisher', 'publishers', 'publishes', 'publishing', 'register', 'registered', 'registers', 'sequences', 'sequencing', 'sexism', 'sexual', 'technical', 'validate', 'validly', 'biases', 'biasing', 'clarity', 'complement', 'complements', 'crucially', 'currency', 'currencies', 'dramatist', 'nuclear', 'radical', 'radically', 'radicals', 'randomly', 'randomness', 'scheduling', 'terminal', 'terminals', 'vehicle', 'vehicles', 'virtual', 'visual', 'visually', 'conversely', 'ethical', 'integral', 'manual', 'manuals', 'medium', 'minimal', 'mutual', 'passively', 'rigidly', 'spherical', 'triggering', 'violate', 'violates', 'consequent', 'consequence', 'credited', 'crediting', 'creditor', 'creditors', 'cultural', 'element', 'elements', 'featuring', 'finally', 'focuses', 'focusing', 'focussing', 'injuries', 'injuring', 'injury', 'positive', 'previous', 'purchaser', 'purchasers', 'purchases', 'purchasing', 'regional', 'relevant', 'relevance', 'residence', 'resident', 'residents', 'resources', 'resourcing', 'insecure', 'strategy', 'strategies', 'strategist', 'strategists', 'accurate', 'aggregate', 'authoring', 'brevity', 'capable', 'edited', 'editing', 'editor', 'editors', 'expertly', 'flexible', 'ignorant', 'ignorance', 'incidence', 'incident', 'incidents', 'indexes', 'indexing', 'interval', 'intervals', 'lecturer', 'lecturers', 'lecturing', 'minimum', 'ministry', 'ministered', 'ministering', 'ministries', 'precedence', 'precedent', 'subsidy', 'subsidies', 'traceable'],
  '001': ['unresolved', 'reassess', 'reassessed', 'redefine', 'redefined', 'redefines', 'uninvolved', 'reoccur', 'reoccurred', 'reoccurs']
};

exports.default = wordList;

/***/ }),

/***/ "JkW7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

__webpack_require__("rq4c");

var _app = __webpack_require__("qLaj");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _app2.default;

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function () {
  var n,
      l,
      u,
      t,
      i,
      o,
      r,
      f,
      e = {},
      c = [],
      a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function s(n, l) {
    for (var u in l) {
      n[u] = l[u];
    }return n;
  }function h(n) {
    var l = n.parentNode;l && l.removeChild(n);
  }function v(n, l, u) {
    var t,
        i,
        o,
        r = arguments,
        f = {};for (o in l) {
      "key" == o ? t = l[o] : "ref" == o ? i = l[o] : f[o] = l[o];
    }if (arguments.length > 3) for (u = [u], o = 3; o < arguments.length; o++) {
      u.push(r[o]);
    }if (null != u && (f.children = u), "function" == typeof n && null != n.defaultProps) for (o in n.defaultProps) {
      void 0 === f[o] && (f[o] = n.defaultProps[o]);
    }return y(n, f, t, i, null);
  }function y(l, u, t, i, o) {
    var r = { type: l, props: u, key: t, ref: i, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: o };return null == o && (r.__v = r), null != n.vnode && n.vnode(r), r;
  }function d(n) {
    return n.children;
  }function p(n, l) {
    this.props = n, this.context = l;
  }function _(n, l) {
    if (null == l) return n.__ ? _(n.__, n.__.__k.indexOf(n) + 1) : null;for (var u; l < n.__k.length; l++) {
      if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    }return "function" == typeof n.type ? _(n) : null;
  }function m(n) {
    var l, u;if (null != (n = n.__) && null != n.__c) {
      for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
        if (null != (u = n.__k[l]) && null != u.__e) {
          n.__e = n.__c.base = u.__e;break;
        }
      }return m(n);
    }
  }function w(l) {
    (!l.__d && (l.__d = !0) && u.push(l) && !k.__r++ || i !== n.debounceRendering) && ((i = n.debounceRendering) || t)(k);
  }function k() {
    for (var n; k.__r = u.length;) {
      n = u.sort(function (n, l) {
        return n.__v.__b - l.__v.__b;
      }), u = [], n.some(function (n) {
        var l, u, t, i, o, r, f;n.__d && (r = (o = (l = n).__v).__e, (f = l.__P) && (u = [], (t = s({}, o)).__v = t, i = z(f, o, t, l.__n, void 0 !== f.ownerSVGElement, null, u, null == r ? _(o) : r), N(u, o), i != r && m(o)));
      });
    }
  }function g(n, l, u, t, i, o, r, f, a, s) {
    var v,
        p,
        m,
        w,
        k,
        g,
        x,
        C = t && t.__k || c,
        A = C.length;for (a == e && (a = null != r ? r[0] : A ? _(t, 0) : null), u.__k = [], v = 0; v < l.length; v++) {
      if (null != (w = u.__k[v] = null == (w = l[v]) || "boolean" == typeof w ? null : "string" == typeof w || "number" == typeof w ? y(null, w, null, null, w) : Array.isArray(w) ? y(d, { children: w }, null, null, null) : null != w.__e || null != w.__c ? y(w.type, w.props, w.key, null, w.__v) : w)) {
        if (w.__ = u, w.__b = u.__b + 1, null === (m = C[v]) || m && w.key == m.key && w.type === m.type) C[v] = void 0;else for (p = 0; p < A; p++) {
          if ((m = C[p]) && w.key == m.key && w.type === m.type) {
            C[p] = void 0;break;
          }m = null;
        }k = z(n, w, m = m || e, i, o, r, f, a, s), (p = w.ref) && m.ref != p && (x || (x = []), m.ref && x.push(m.ref, null, w), x.push(p, w.__c || k, w)), null != k ? (null == g && (g = k), a = b(n, w, m, C, r, k, a), s || "option" != u.type ? "function" == typeof u.type && (u.__d = a) : n.value = "") : a && m.__e == a && a.parentNode != n && (a = _(m));
      }
    }if (u.__e = g, null != r && "function" != typeof u.type) for (v = r.length; v--;) {
      null != r[v] && h(r[v]);
    }for (v = A; v--;) {
      null != C[v] && j(C[v], C[v]);
    }if (x) for (v = 0; v < x.length; v++) {
      $(x[v], x[++v], x[++v]);
    }
  }function b(n, l, u, t, i, o, r) {
    var f, e, c;if (void 0 !== l.__d) f = l.__d, l.__d = void 0;else if (i == u || o != r || null == o.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(o), f = null;else {
      for (e = r, c = 0; (e = e.nextSibling) && c < t.length; c += 2) {
        if (e == o) break n;
      }n.insertBefore(o, r), f = r;
    }return void 0 !== f ? f : o.nextSibling;
  }function x(n, l, u, t, i) {
    var o;for (o in u) {
      "children" === o || "key" === o || o in l || A(n, o, null, u[o], t);
    }for (o in l) {
      i && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || A(n, o, l[o], u[o], t);
    }
  }function C(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || a.test(l) ? u : u + "px";
  }function A(n, l, u, t, i) {
    var o, r;if (i && "className" == l && (l = "class"), "style" === l) {
      if ("string" == typeof u) n.style = u;else {
        if ("string" == typeof t && (n.style = t = ""), t) for (l in t) {
          u && l in u || C(n.style, l, "");
        }if (u) for (l in u) {
          t && u[l] === t[l] || C(n.style, l, u[l]);
        }
      }
    } else "o" === l[0] && "n" === l[1] ? (o = l !== (l = l.replace(/Capture$/, "")), (r = l.toLowerCase()) in n && (l = r), l = l.slice(2), n.l || (n.l = {}), n.l[l] = u, u ? t || n.addEventListener(l, P, o) : n.removeEventListener(l, P, o)) : "list" !== l && "tagName" !== l && "form" !== l && "type" !== l && "size" !== l && "download" !== l && "href" !== l && !i && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u && !/^ar/.test(l) ? n.removeAttribute(l) : n.setAttribute(l, u));
  }function P(l) {
    this.l[l.type](n.event ? n.event(l) : l);
  }function E(n, l, u) {
    var t, i;for (t = 0; t < n.__k.length; t++) {
      (i = n.__k[t]) && (i.__ = n, i.__e && ("function" == typeof i.type && i.__k.length > 1 && E(i, l, u), l = b(u, i, i, n.__k, null, i.__e, l), "function" == typeof n.type && (n.__d = l)));
    }
  }function z(l, u, t, i, o, r, f, e, c) {
    var a,
        h,
        v,
        y,
        _,
        m,
        w,
        k,
        b,
        x,
        C,
        A = u.type;if (void 0 !== u.constructor) return null;(a = n.__b) && a(u);try {
      n: if ("function" == typeof A) {
        if (k = u.props, b = (a = A.contextType) && i[a.__c], x = a ? b ? b.props.value : a.__ : i, t.__c ? w = (h = u.__c = t.__c).__ = h.__E : ("prototype" in A && A.prototype.render ? u.__c = h = new A(k, x) : (u.__c = h = new p(k, x), h.constructor = A, h.render = F), b && b.sub(h), h.props = k, h.state || (h.state = {}), h.context = x, h.__n = i, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != A.getDerivedStateFromProps && (h.__s == h.state && (h.__s = s({}, h.__s)), s(h.__s, A.getDerivedStateFromProps(k, h.__s))), y = h.props, _ = h.state, v) null == A.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);else {
          if (null == A.getDerivedStateFromProps && k !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(k, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(k, h.__s, x) || u.__v === t.__v) {
            h.props = k, h.state = h.__s, u.__v !== t.__v && (h.__d = !1), h.__v = u, u.__e = t.__e, u.__k = t.__k, h.__h.length && f.push(h), E(u, e, l);break n;
          }null != h.componentWillUpdate && h.componentWillUpdate(k, h.__s, x), null != h.componentDidUpdate && h.__h.push(function () {
            h.componentDidUpdate(y, _, m);
          });
        }h.context = x, h.props = k, h.state = h.__s, (a = n.__r) && a(u), h.__d = !1, h.__v = u, h.__P = l, a = h.render(h.props, h.state, h.context), h.state = h.__s, null != h.getChildContext && (i = s(s({}, i), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (m = h.getSnapshotBeforeUpdate(y, _)), C = null != a && a.type == d && null == a.key ? a.props.children : a, g(l, Array.isArray(C) ? C : [C], u, t, i, o, r, f, e, c), h.base = u.__e, h.__h.length && f.push(h), w && (h.__E = h.__ = null), h.__e = !1;
      } else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = T(t.__e, u, t, i, o, r, f, c);(a = n.diffed) && a(u);
    } catch (l) {
      u.__v = null, n.__e(l, u, t);
    }return u.__e;
  }function N(l, u) {
    n.__c && n.__c(u, l), l.some(function (u) {
      try {
        l = u.__h, u.__h = [], l.some(function (n) {
          n.call(u);
        });
      } catch (l) {
        n.__e(l, u.__v);
      }
    });
  }function T(n, l, u, t, i, o, r, f) {
    var a,
        s,
        h,
        v,
        y,
        d = u.props,
        p = l.props;if (i = "svg" === l.type || i, null != o) for (a = 0; a < o.length; a++) {
      if (null != (s = o[a]) && ((null === l.type ? 3 === s.nodeType : s.localName === l.type) || n == s)) {
        n = s, o[a] = null;break;
      }
    }if (null == n) {
      if (null === l.type) return document.createTextNode(p);n = i ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type, p.is && { is: p.is }), o = null, f = !1;
    }if (null === l.type) d !== p && n.data !== p && (n.data = p);else {
      if (null != o && (o = c.slice.call(n.childNodes)), h = (d = u.props || e).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !f) {
        if (null != o) for (d = {}, y = 0; y < n.attributes.length; y++) {
          d[n.attributes[y].name] = n.attributes[y].value;
        }(v || h) && (v && h && v.__html == h.__html || (n.innerHTML = v && v.__html || ""));
      }x(n, p, d, i, f), v ? l.__k = [] : (a = l.props.children, g(n, Array.isArray(a) ? a : [a], l, u, t, "foreignObject" !== l.type && i, o, r, e, f)), f || ("value" in p && void 0 !== (a = p.value) && a !== n.value && A(n, "value", a, d.value, !1), "checked" in p && void 0 !== (a = p.checked) && a !== n.checked && A(n, "checked", a, d.checked, !1));
    }return n;
  }function $(l, u, t) {
    try {
      "function" == typeof l ? l(u) : l.current = u;
    } catch (l) {
      n.__e(l, t);
    }
  }function j(l, u, t) {
    var i, o, r;if (n.unmount && n.unmount(l), (i = l.ref) && (i.current && i.current !== l.__e || $(i, null, u)), t || "function" == typeof l.type || (t = null != (o = l.__e)), l.__e = l.__d = void 0, null != (i = l.__c)) {
      if (i.componentWillUnmount) try {
        i.componentWillUnmount();
      } catch (l) {
        n.__e(l, u);
      }i.base = i.__P = null;
    }if (i = l.__k) for (r = 0; r < i.length; r++) {
      i[r] && j(i[r], u, t);
    }null != o && h(o);
  }function F(n, l, u) {
    return this.constructor(n, u);
  }function H(l, u, t) {
    var i, r, f;n.__ && n.__(l, u), r = (i = t === o) ? null : t && t.__k || u.__k, l = v(d, null, [l]), f = [], z(u, (i ? u : t || u).__k = l, r || e, e, void 0 !== u.ownerSVGElement, t && !i ? [t] : r ? null : u.childNodes.length ? c.slice.call(u.childNodes) : null, f, t || e, i), N(f, l);
  }n = { __e: function __e(n, l) {
      for (var u, t; l = l.__;) {
        if ((u = l.__c) && !u.__) try {
          if (u.constructor && null != u.constructor.getDerivedStateFromError && (t = !0, u.setState(u.constructor.getDerivedStateFromError(n))), null != u.componentDidCatch && (t = !0, u.componentDidCatch(n)), t) return w(u.__E = u);
        } catch (l) {
          n = l;
        }
      }throw n;
    } }, l = function l(n) {
    return null != n && void 0 === n.constructor;
  }, p.prototype.setState = function (n, l) {
    var u;u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = s({}, this.state), "function" == typeof n && (n = n(s({}, u), this.props)), n && s(u, n), null != n && this.__v && (l && this.__h.push(l), w(this));
  }, p.prototype.forceUpdate = function (n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), w(this));
  }, p.prototype.render = d, u = [], t = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, k.__r = 0, o = e, r = 0, f = { render: H, hydrate: function hydrate(n, l) {
      H(n, l, o);
    }, createElement: v, h: v, Fragment: d, createRef: function createRef() {
      return { current: null };
    }, isValidElement: l, Component: p, cloneElement: function cloneElement(n, l, u) {
      var t,
          i,
          o,
          r = arguments,
          f = s({}, n.props);for (o in l) {
        "key" == o ? t = l[o] : "ref" == o ? i = l[o] : f[o] = l[o];
      }if (arguments.length > 3) for (u = [u], o = 3; o < arguments.length; o++) {
        u.push(r[o]);
      }return null != u && (f.children = u), y(n.type, f, t || n.key, i || n.ref, null);
    }, createContext: function createContext(n, l) {
      var u = { __c: l = "__cC" + r++, __: n, Consumer: function Consumer(n, l) {
          return n.children(l);
        }, Provider: function Provider(n, u, t) {
          return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function () {
            return t;
          }, this.shouldComponentUpdate = function (n) {
            this.props.value !== n.value && u.some(w);
          }, this.sub = function (n) {
            u.push(n);var l = n.componentWillUnmount;n.componentWillUnmount = function () {
              u.splice(u.indexOf(n), 1), l && l.call(n);
            };
          }), n.children;
        } };return u.Provider.__ = u.Consumer.contextType = u;
    }, toChildArray: function n(l, u) {
      return u = u || [], null == l || "boolean" == typeof l || (Array.isArray(l) ? l.some(function (l) {
        n(l, u);
      }) : u.push(l)), u;
    }, __u: j, options: n }, ( false ? "undefined" : _typeof(module)) < "u" ? module.exports = f : self.preact = f;
}();
//# sourceMappingURL=preact.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("l262")(module)))

/***/ }),

/***/ "L23q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("TNCl") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "LIV4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = collectData;

var _expandedWords = __webpack_require__("JdXh");

var _expandedWords2 = _interopRequireDefault(_expandedWords);

var _shuffle = __webpack_require__("jta0");

var _shuffle2 = _interopRequireDefault(_shuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function collectData(stressPattern) {
  var stressArray = Object.keys(_expandedWords2.default);
  var stressIndex = stressArray.indexOf(stressPattern.stress);
  var syllablesInFirstPattern = stressPattern.stress.length;

  var firstStressArray = _expandedWords2.default[stressPattern.stress].map(function (word) {
    return {
      word: word,
      stress: stressPattern.stress
    };
  });
  // make sure the word that we "match with" isn't in the cards to click
  var filteredFirstStressArray = firstStressArray.filter(function (t) {
    return t.word !== stressPattern.word;
  });

  // get a stress pattern that's not the one we selected
  // also use same number of syllables for the distractor items
  var number = stressIndex;
  var syllablesInSecondPattern = 0;
  while (number === stressIndex || syllablesInFirstPattern !== syllablesInSecondPattern) {
    number = Math.floor(Math.random() * Math.floor(stressArray.length));
    syllablesInSecondPattern = stressArray[number].length;
  }

  var secondStressSound = stressArray[number];
  var secondStressArray = _expandedWords2.default[secondStressSound].map(function (word) {
    return {
      word: word,
      stress: secondStressSound
    };
  });

  var shuffledFirst = (0, _shuffle2.default)(filteredFirstStressArray);
  var shuffledSecond = (0, _shuffle2.default)(secondStressArray);

  return [].concat(shuffledFirst.slice(0, 6), shuffledSecond.slice(0, 6));
}

/***/ }),

/***/ "QXgo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = generateGridCards;

var _collectData = __webpack_require__("LIV4");

var _collectData2 = _interopRequireDefault(_collectData);

var _shuffle = __webpack_require__("jta0");

var _shuffle2 = _interopRequireDefault(_shuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateGridCards(stressPattern) {
  var randoArray = (0, _collectData2.default)(stressPattern);

  var shuffledRando = (0, _shuffle2.default)(randoArray);

  return [].concat(shuffledRando).map(function (card, idx) {
    return { key: idx, values: card };
  });
}

/***/ }),

/***/ "jta0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// shameless use of the Knuth (Fisher Yates) Shuffle
var shuffle = function shuffle(array) {

	var currentIndex = array.length;
	var temporaryValue = void 0,
	    randomIndex = void 0;

	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;

		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}
	return array;
};

exports.default = shuffle;

/***/ }),

/***/ "kLLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("B8ml") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "klTG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var stressMap = {
  '0': '-',
  '1': '\u2022'
};

var stressDotMap = function stressDotMap(stressPattern) {
  return stressPattern.split('').map(function (syllable) {
    return stressMap[syllable];
  });
};

exports.default = stressDotMap;

/***/ }),

/***/ "l262":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "qLaj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

var _utils = __webpack_require__("DHvs");

var _home = __webpack_require__("E1C8");

var _home2 = _interopRequireDefault(_home);

var _game = __webpack_require__("kLLQ");

var _game2 = _interopRequireDefault(_game);

var _loss = __webpack_require__("GoAI");

var _loss2 = _interopRequireDefault(_loss);

var _select = __webpack_require__("L23q");

var _select2 = _interopRequireDefault(_select);

var _win = __webpack_require__("qbIe");

var _win2 = _interopRequireDefault(_win);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      selectedStress: ''
    }, _this.selectStress = function (selectedStress) {
      return _this.setState({ selectedStress: selectedStress });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  App.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      { id: 'app' },
      (0, _preact.h)(
        _preactRouter.Router,
        { onChange: this.handleRoute },
        (0, _preact.h)(_home2.default, { path: (0, _utils.setupPath)() + '/' }),
        (0, _preact.h)(_game2.default, { path: (0, _utils.setupPath)() + '/game', stress: this.state.selectedStress }),
        (0, _preact.h)(_loss2.default, { path: (0, _utils.setupPath)() + '/loss' }),
        (0, _preact.h)(_select2.default, { path: (0, _utils.setupPath)() + '/select', onSelectStress: this.selectStress }),
        (0, _preact.h)(_win2.default, { path: (0, _utils.setupPath)() + '/win' })
      )
    );
  };

  return App;
}(_preact.Component);

exports.default = App;

/***/ }),

/***/ "qbIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("SIQA") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yQgl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setupPath = function setupPath() {
    var gamePath = void 0;
    switch ("production") {
        case 'production':
            gamePath = '/stress-game';
            break;
        default:
            gamePath = '';
            break;
    };

    return gamePath;
};

exports.default = setupPath;

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.95416.js